import { AxiosResponse } from 'axios';
import { axios } from '@repository/RequestClient';
import PassReviewPostSaveRq from '@domain/rq/passReview/PassReviewPostSaveRq';
import PassReviewQuestionListRq from '@domain/rq/passReview/PassReviewQuestionListRq';
import PassReviewPostListGetRq from '@domain/rq/passReview/PassReviewPostListGetRq';
import PassReviewPostListGetRs from '@domain/rs/passReview/PassReviewPostListGetRs';
import PassReviewPostSaveRs from '@domain/rs/passReview/PassReviewPostSaveRs';
import PassReviewPostGetRs from '@domain/rs/passReview/PassReviewPostGetRs';
import PassReviewQuestionListRs from '@domain/rs/passReview/PassReviewQuestionListRs';
import PassReviewBannerListRs from '@domain/rs/passReview/PassReviewBannerListRs';
import PassReviewCommentListGetRs from '@domain/rs/passReview/PassReviewCommentListGetRs';

export default interface PassReviewRepo {
  //합격 후기 게시글 목록 조회
  fetchPassReviewPosts(rq: PassReviewPostListGetRq): Promise<AxiosResponse<PassReviewPostListGetRs>>;
  //합격 후기 게시글 등록
  createPassReviewPosts(rq: PassReviewPostSaveRq): Promise<AxiosResponse<PassReviewPostSaveRs>>;
  //합격 후기 게시글 상세 조회
  fetchPassReviewPostDetail(sn: number): Promise<AxiosResponse<PassReviewPostGetRs>>;
  //합격 후기 게시글 수정
  updatePassReviewPosts(sn: number, rq: PassReviewPostSaveRq): Promise<AxiosResponse<PassReviewPostSaveRs>>;
  //합격 후기 게시글 삭제
  deletePassReviewPosts(sn: number): Promise<AxiosResponse<boolean>>;
  //합격 후기 게시글 질문 목록 조회
  fetchPassReviewPostQuestions(rq: PassReviewQuestionListRq): Promise<AxiosResponse<PassReviewQuestionListRs>>;
  //합격 후기 배너 목록 조회
  fetchPassReviewBanners(): Promise<AxiosResponse<PassReviewBannerListRs>>;
  //합격 후기 댓글 목록 조회
  fetchPassReviewPostComments(sn: number): Promise<AxiosResponse<PassReviewCommentListGetRs>>;
  //합격 후기 댓글 등록
  createPassReviewPostComments(sn: number, comment: string): Promise<AxiosResponse<boolean>>;
  //합격 후기 댓글 수정
  updatePassReviewPostComments(sn: number, commentSn: number, comment: string): Promise<AxiosResponse<boolean>>;
  //합격 후기 댓글 삭제
  deletePassReviewPostComments(sn: number, commentSn: number): Promise<AxiosResponse<boolean>>;
  //합격 후기 게시글 Top5
  fetchPassReviewPostsTop(): Promise<AxiosResponse<PassReviewPostListGetRs>>;
}

export class RemotePassReviewRepo implements PassReviewRepo {
  fetchPassReviewPosts(rq: PassReviewPostListGetRq) {
    return axios.get<PassReviewPostListGetRs>('/pass-review-posts', { params: rq });
  }

  createPassReviewPosts(rq: PassReviewPostSaveRq) {
    return axios.post<PassReviewPostSaveRs>('/pass-review-posts', rq);
  }
  fetchPassReviewPostDetail(sn: number) {
    return axios.get<PassReviewPostGetRs>(`/pass-review-posts/${sn}`);
  }
  updatePassReviewPosts(sn: number, rq: PassReviewPostSaveRq) {
    return axios.put<PassReviewPostSaveRs>(`/pass-review-posts/${sn}`, rq);
  }
  deletePassReviewPosts(sn: number) {
    return axios.delete<boolean>(`/pass-review-posts/${sn}`);
  }
  fetchPassReviewPostQuestions(rq: PassReviewQuestionListRq) {
    return axios.get<PassReviewQuestionListRs>('/pass-review-posts/questions', { params: rq });
  }
  fetchPassReviewBanners() {
    return axios.get<PassReviewBannerListRs>('/pass-review-posts/banners');
  }
  fetchPassReviewPostComments(sn: number) {
    return axios.get<PassReviewCommentListGetRs>(`/pass-review-posts/${sn}/comments`);
  }
  createPassReviewPostComments(sn: number, comment: string) {
    return axios.post<boolean>(`/pass-review-posts/${sn}/comments`, { comment });
  }
  updatePassReviewPostComments(sn: number, commentSn: number, comment: string) {
    return axios.put<boolean>(`/pass-review-posts/${sn}/comments/${commentSn}`, { comment });
  }
  deletePassReviewPostComments(sn: number, commentSn: number) {
    return axios.delete<boolean>(`/pass-review-posts/${sn}/comments/${commentSn}`);
  }
  fetchPassReviewPostsTop() {
    return axios.get<PassReviewPostListGetRs>('/pass-review-posts/top5');
  }
}
